import { createInertiaApp, type ResolvedComponent } from '@inertiajs/svelte';
import { hydrate, mount } from 'svelte';
import '../css/app.css';
import './bootstrap';

import { defineRoutes } from 'momentum-trail';
import routes from './routes.json';
defineRoutes(routes);

import ErrorOverlay from '@/components/ErrorOverlay.svelte';
import { initErrorHandler, showErrorOverlay } from '@/lib/errorHandler.svelte';

// Initialize global error handlers
initErrorHandler();

// Mount error overlay to a separate element
const errorOverlayEl = document.createElement('div');
errorOverlayEl.id = 'error-overlay';
document.body.appendChild(errorOverlayEl);
mount(ErrorOverlay, { target: errorOverlayEl });

createInertiaApp({
    resolve: (name: string) => {
        const pages = import.meta.glob<ResolvedComponent>('./pages/**/*.svelte', { eager: true });
        return pages[`./pages/${name}.svelte`];
    },
    setup({ el, App, props }) {
        try {
            if (el && el.dataset.serverRendered === 'true') {
                hydrate(App, { target: el, props });
            } else if (el) {
                mount(App, { target: el, props });
            }
        } catch (error) {
            // Catch errors during component initialization/mounting
            console.error('[Inertia Mount Error]', error);
            showErrorOverlay(error instanceof Error ? error : new Error(String(error)));
        }
    },
});
